export default () => ({
  '1609347344139': {
    id: 1609347344139,
    titulo: 'LOCAL ESTÁ ACESSÍVEL?',
    perguntas: {
      '1609347360159': {
        id: 1609347360159,
        titulo: 'O local está acessível?',
        tipo: 'local_acessivel',
        obrigatorio: true,
        min_fotos: 1,
        order: 0,
      },
    },
    order: 0,
  },
  '1432212113437': {
    id: '1432212113437',
    titulo: 'Vistoria fiscal',
    perguntas: {
      '1432212161106': {
        id: '1432212161106',
        alternativas: {
          '1432212219885': {
            id: '1432212219885',
            titulo: 'Alvará Renovado',
            order: 0,
          },
          '1432212226570': {
            id: '1432212226570',
            titulo: 'Encerrada Atividade no Local',
            order: 1,
          },
          '1432212240790': {
            id: '1432212240790',
            titulo: 'Em funcionamento',
            peso: '0',
            order: 2,
          },
          '1455193550140': {
            id: '1455193550140',
            titulo: 'Atividade Paralisada e/ou Não Iniciada',
            order: 3,
          },
        },
        obrigatorio: false,
        min_fotos: 0,
        titulo: 'Situação do estabelecimento',
        tipo: 'radio',
        order: 0,
      },
      '1580781675688': {
        id: 1580781675688,
        titulo: 'DESEJA EMITIR NOTIFICAÇÃO?',
        tipo: 'sim_nao',
        obrigatorio: false,
        min_fotos: 0,
        order: 1,
      },
      '1580781648401': {
        id: 1580781648401,
        titulo: 'EMITIR NOTIFICAÇÃO',
        tipo: 'notificar',
        obrigatorio: false,
        min_fotos: 4,
        notificacao_livre: true,
        multiplas_notificacoes: true,
        condicao: {
          grupo_id: '1432212113437',
          pergunta_id: 1580781675688,
          operacao: 'eq',
          resposta: true,
        },
        order: 2,
      },
    },
    order: 1,
    condicao: null,
  },
})
